import React from 'react';
import {Box, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import styles from "./IntegrationCard.module.scss"
import {IntegrationDetails} from "./IntegrationDetails"
import {resolveNameForModelPlatform} from "../../api/enum/ModelPlatform"

function IntegrationCard({platform, className, path, iconSrc}: IntegrationDetails) {
    const navigate = useNavigate()

    return (
        <div className={`${className} ${styles.card}`} onClick={() => navigate(`./${path}`)}>
            <Stack className={styles.inside} spacing={0.5}>
                {iconSrc && <img src={iconSrc} />}
                <Typography variant="h2">
                    {resolveNameForModelPlatform(platform)}
                </Typography>
            </Stack>
        </div>
    );
}

export default IntegrationCard;
